import { Component, OnInit, HostListener, inject, output, model } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Store } from '@ngxs/store';
import { SocialAuthService, FacebookLoginProvider, MicrosoftLoginProvider, GoogleSigninButtonDirective } from '@abacritt/angularx-social-login';
import { NzMessageService } from 'ng-zorro-antd/message';
import { GenericService } from 'src/app/services/generic.service';
import { MsalLoginService } from 'src/app/services/msal.service';
import { GenericActions } from 'src/app/store/generic.actions';
import { GenericState } from 'src/app/store/generic.state';
import { IpDetectorState } from 'src/app/store/ip-detector/ip-detector.state';
import { filter, take, firstValueFrom, lastValueFrom } from 'rxjs';
import * as _ from 'underscore';
import { SITE_DATA } from 'src/app/productization/default.constant';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NgClass } from '@angular/common';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzInputModule } from 'ng-zorro-antd/input';
import { MatFormField, MatInput, MatSuffix } from '@angular/material/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { MatCheckbox } from '@angular/material/checkbox';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.scss'],
    imports: [NzModalModule, GoogleSigninButtonDirective, FormsModule, ReactiveFormsModule, NgClass, NzSpaceModule, NzInputModule, MatFormField, MatInput, MatSuffix, NzSelectModule, NzGridModule, MatCheckbox, RouterLink, NzButtonModule]
})
export class RegistrationComponent implements OnInit {
	private msalLoginService = inject(MsalLoginService);
	private nzMessage = inject(NzMessageService);
	private socialAuthService = inject(SocialAuthService);
	private store = inject(Store);
	private genericService = inject(GenericService);
	private route = inject(ActivatedRoute);
	private router = inject(Router);

	readonly isShowRegistration = model(false);
	readonly hideRegistration = output<boolean>();
	readonly showLoginModal = output();
	private readonly getIpAddress = this.store.select(IpDetectorState.getIp);
	private readonly genericLookup = this.store.select(GenericState.getGeneric);
	private readonly genericResult = this.store.select<any>(GenericState.getGeneric);
	public geoCountries: any = [];
	public geoProvinces: any = [];
	public sources: any = [];

	public isChecked = false;
	public showTerms = false;
	public showPassword = false;
	public thankModal = false;
	public isNotVerified = false;

	public isSocialSignUp = false;
	public socialData: any;

	public registrationForm: FormGroup;

	private strongPasswordRegx: RegExp =
		/^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=.*[!@#$%^&*])(?=\D*\d).{8,}$/;

	public ClickedCreateAccount = false;

	public siteData = SITE_DATA;

	linkedInCredentials = {
		clientId: '86h8gq86x71ywc',
		redirectUrl: 'https://localhost:4200',
		scope: 'openid%20profile%20w_member_social%20email' // To read basic user profile data and email
	};

	linkedInToken: any;
	private readonly forMobileSize = 1024;
	private screenWidth: number;
	public socialBtnWidth = 220;
	private sBtnWidth: any = {
		web: 220,
		mobile: 300
	};

	public getSourceId: any = null;
	private selectedCountry: any = null;
	private selectedCountryCode: any = null;

	constructor() {
		this.route.queryParams.subscribe((params: any) => {
			if (params.csuid) {
				this.qrReferral(params.csuid);
			}
			if (params.id) {
				localStorage.setItem('referralJxId', params.id);
			}
			if (params.ref) {
				localStorage.setItem('referralId', params.ref);
			}
		});
	}

	@HostListener('window:resize')
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		this.socialBtnWidth =
			this.screenWidth <= this.forMobileSize
				? this.sBtnWidth.mobile
				: this.sBtnWidth.web;
	}
	private qrReferral(csuid: string) {
		localStorage.setItem('csUid', csuid);
		localStorage.setItem('referralId', '1');
		localStorage.removeItem('referralJxId');
	}
	async ngOnInit(): Promise<void> {
		this.buildForm();
		this.genericResult?.subscribe((data: any) => {
			this.geoCountries = data.geoCountries;
			this.geoProvinces = data.geoProvinces;
			if (data.sources.length > 0) {
				this.sources = data.sources;
				let businessCard = this.sources.find(
					(source: any) => source.option === 'Business Card'
				);

				if (
					data.modalRegistration &&
					this.registrationForm.value.country === null &&
					this.geoCountries.length > 0
				) {
					this.getCountryOrigin();
				}

				if (businessCard && localStorage.getItem('csUid') !== null) {
					this.registrationForm.patchValue({
						sourceId: businessCard.id // CS Business card Referral
					});
				}
			}
		});
		this.store.dispatch(new GenericActions.GetGeoCountries());

		this.linkedInToken = this.route.snapshot.queryParams['code'];
		this.screenWidth = window.innerWidth;
		this.socialBtnWidth =
			this.screenWidth <= this.forMobileSize
				? this.sBtnWidth.mobile
				: this.sBtnWidth.web;

		this.socialAuthService.authState.subscribe({
			next: (data: any) => {
				this.registrationForm.get('password')?.clearValidators();
				this.registrationForm.get('password')?.disable();
				this.isSocialSignUp = true;
				if (data.lastName === undefined) {
					this.registrationForm.get('lastName')?.clearValidators();
				}

				let dataProp: any = {
					firstName: data.firstName,
					lastName: data.lastName ? data.lastName : '',
					email: data.email,
					pictureUrl: data.photoUrl
				};

				if (data.provider === 'GOOGLE') {
					dataProp.googleId = data.id;
					this.registrationForm.patchValue(dataProp);
				}

				if (data.provider === 'FACEBOOK') {
					dataProp.facebookId = data.id;
					this.registrationForm.patchValue(dataProp);
				}
				this.registrationForm.updateValueAndValidity();
			},
			error: (error) => {
				if (
					error ===
					'Login providers not ready yet. Are there errors on your console?'
				) {
					this.nzMessage.error(
						'Please accept cookies consent. Before using Social Sign Up.'
					);
				}
			}
		});
	}

	private buildForm() {
		this.registrationForm = new FormGroup({
			googleId: new FormControl(''),
			facebookId: new FormControl(''),
			linkedInId: new FormControl(''),
			microsoftId: new FormControl(''),
			firstName: new FormControl('', Validators.required),
			lastName: new FormControl('', Validators.required),
			friendlyName: new FormControl('', [
				Validators.required,
				Validators.minLength(2)
			]),
			email: new FormControl('', [
				Validators.required,
				Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,20}$')
			]),
			stateProvice: new FormControl(null, [Validators.required]),
			country: new FormControl(null, [Validators.required]),
			pictureUrl: new FormControl(''),
			countryCode: new FormControl(''),
			sourceId: new FormControl(null, [Validators.required]),
			phoneNumber: new FormControl('', [
				Validators.required,
				Validators.minLength(6)
			]),
			password: new FormControl('', [
				Validators.required,
				Validators.pattern(this.strongPasswordRegx)
			]),
			csUid: new FormControl('')
		});

		const getReferralId = localStorage.getItem('referralId');
		if (getReferralId && this.isShowRegistration()) {
			this.getSourceId = null;
			this.genericService
				.get(`Applicant/GetSourceId/${getReferralId}`)
				.subscribe((data: any) => {
					this.getSourceId = data;
					this.registrationForm.patchValue({
						sourceId: data
					});
				});
		}
	}

	public onChangeCountry(country: any) {
		this.store.dispatch(new GenericActions.GetGeoProvinces(country.code));
		this.selectedCountry = country;
		this.selectedCountryCode = country.countryCode;
		this.genericService
			.get(`Geo/countries/${country.code}`)
			.subscribe((data: any) => {
				this.registrationForm.patchValue({
					countryCode: data.countryCode,
					stateProvice: null
				});
			});
	}

	public handleCancel() {
		this.hideRegistration.emit(false);
		this.ClickedCreateAccount = false;
		this.changeSocialSignUp();
		setTimeout(() => {
			this.showTerms = false;
			this.isChecked = false;
			this.thankModal = false;
		}, 100);
	}

	public handleOk() {
		this.hideRegistration.emit(false);
		this.ClickedCreateAccount = false;
		setTimeout(() => {
			this.showTerms = false;
			this.isChecked = false;
			this.thankModal = false;
			this.buildForm();
		}, 100);
	}

	public clickCheckBox() {
		if (this.isChecked) {
			this.showTerms = true;
		}
	}

	public showLogin() {
		this.showLoginModal.emit();
		this.msalLoginService.msalLogin();
	}

	public facebookSignUp() {
		this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID);
	}

	public microsoftSignUp() {
		this.socialAuthService
			.signIn(MicrosoftLoginProvider.PROVIDER_ID)
			.then((data: any) => {
				this.registrationForm.get('password')?.disable();
				this.isSocialSignUp = true;
				this.registrationForm.patchValue({
					firstName: data.firstName,
					lastName: data.lastName,
					email: data.email,
					pictureUrl: data.photoUrl,
					microsoftId: data.response.idTokenClaims.sub
				});
			});
	}

	public linkedInSignUp() {
		window.location.href = `https://www.linkedin.com/uas/oauth2/authorization?response_type=code&client_id=${this.linkedInCredentials.clientId}&redirect_uri=${this.linkedInCredentials.redirectUrl}&scope=${this.linkedInCredentials.scope}`;
	}

	public changeSocialSignUp() {
		this.isSocialSignUp = false;
		this.socialData = null;
		this.registrationForm.get('password')?.enable();
		this.buildForm();
		if (this.selectedCountry !== null) {
			this.registrationForm.patchValue({
				country: this.selectedCountry,
				countryCode: this.selectedCountryCode
			});
			this.registrationForm.updateValueAndValidity();
		}
	}

	public saveNewAccount() {
		if (this.registrationForm.value.email.includes('@cloudstaff.inc')) {
			this.nzMessage.error(
				'Unable to use this email. Please use your @cloudstaff.com email address to register.'
			);
			return;
		}

		this.registrationForm.markAllAsTouched();
		if (this.registrationForm.status === 'VALID' && !this.isChecked) {
			this.nzMessage.error('Please accept the terms and conditions.');
		}

		if (this.registrationForm.status === 'INVALID' || !this.isChecked) return;
		this.ClickedCreateAccount = true;

		let tempReferralJxId = localStorage.getItem('referralJxId');
		this.registrationForm.value.referralBy = tempReferralJxId
			? tempReferralJxId
			: '';
		let tempCsUid = localStorage.getItem('csUid');
		this.registrationForm.value.csUid = tempCsUid ?? null;
		if (tempCsUid) {
			this.registrationForm.value.csUid = tempCsUid;
		}

		let tempReferralId = localStorage.getItem('referralId');
		this.registrationForm.value.refId = tempReferralId ? +tempReferralId : 0;
		let tempCountry = this.registrationForm.value.country.name;
		const id = this.nzMessage.loading('Creating your profile.', {
			nzDuration: 0
		}).messageId;
		this.registrationForm.value.country = tempCountry;
		if (!this.registrationForm.value.password) {
			this.registrationForm.value.password = '';
		}
		this.registrationForm.value.friendlyName =
			this.registrationForm.value.friendlyName?.trim();
		this.genericService
			.post('Applicant/RegisterAccount', this.registrationForm.value)
			.subscribe({
				next: () => {
					this.removeRefQueryString();
					this.nzMessage.remove(id);
					this.thankModal = true;
					this.ClickedCreateAccount = false;
				},
				error: (error) => {
					this.nzMessage.remove(id);
					if (error === 'Email not yet verified') {
						this.thankModal = true;
						this.isNotVerified = true;
					}
					this.ClickedCreateAccount = false;
				},
				complete: () => {
					this.nzMessage.remove(id);
					this.thankModal = true;
					this.isNotVerified = false;
					this.ClickedCreateAccount = false;
				}
			});
	}

	public resendCode() {
		const payload = {
			value: this.registrationForm.value.email
		};

		this.genericService
			.post(`Applicant/ReSendVerificationCode`, payload)
			.subscribe(() => {
				this.nzMessage.success('Verification code sent.');
			});
	}

	public onBlur(property: string) {
		let prop = this.registrationForm.get(property);
		prop?.setValue(prop?.value.sanitizeText());
		prop?.updateValueAndValidity();
	}

	public redirectJoblist(): void {
		this.isShowRegistration.set(false);
		this.router.navigate(['/job-list']);
	}

	private removeRefQueryString(): void {
		const url = new URL(window.location.href);
		let dataCheck = url.searchParams.get('ref');
		if (dataCheck === null) return;
		url.searchParams.delete('ref');
		window.history.replaceState({}, document.title, url.toString());
	}

	private async getCountryOrigin(): Promise<void> {
		const countryOrigin: any = await firstValueFrom(
			this.getIpAddress.pipe(
				filter((e: any) => !_.isEmpty(e)),
				take(1)
			)
		);
		const countryList: any = await lastValueFrom(
			this.genericLookup?.pipe(
				filter((e: any) => e.lookUpCountries.length > 0),
				take(1)
			)
		);

		const initialCountry =
			this.siteData.defaultCountry === 'none'
				? countryOrigin.country_name
				: this.siteData.defaultCountry;

		if (countryList.lookUpCountries?.includes(initialCountry)) {
			let defaultCountry = this.geoCountries.filter(
				(e: any) => e.name === initialCountry
			)[0];
			this.registrationForm.patchValue({
				country: defaultCountry,
				countryCode: defaultCountry?.countryCode
			});
			this.selectedCountry = defaultCountry;
			this.selectedCountryCode = defaultCountry?.countryCode;
			this.registrationForm.updateValueAndValidity();
		}
	}
}
